import { ReactNode } from "react";

type Props = {
  title: string;
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
};

export const PageHeader = (props: Props) => {
  return <div className="page-header">{props.children}</div>;
};
